module.exports = __webpack_public_path__ + "static/img/bg-fr.2949c4e4.png";